import { t } from "i18next"

export type EstimatedTime = {
  avg: number // in seconds
  startTime: number // timestamp
}

export const formatTime = (estimatedTime: EstimatedTime, elapsedTime: number): string => {
  const timeLeft = Math.max(estimatedTime.avg - elapsedTime, 0)

  if (timeLeft <= 10) {
    return t("pages.translate.moments_away")
  }

  // Convert timeLeft to minutes, rounding up
  const minutesLeft = Math.ceil(timeLeft / 60)

  const minutesLeftText =
    minutesLeft > 1 ? t("pages.translate.minutes_left") : t("pages.translate.minute_left")

  return `~ ${minutesLeft} ${minutesLeftText}`
}
